module.exports = __webpack_public_path__ + "img/home-like.f5662fab.png";